<h2 mat-dialog-title>Upload Image</h2>
<mat-dialog-content class="mat-typography">
  <div class="custom-file" *ngIf="!isUploading && percentCompleted <= 0">
    <input type="file" class="custom-file-input" [formControl]="file" (change)="onFileChange($event.target.files)" id="customFile">
    <label class="custom-file-label" for="customFile">{{selectedFile ? selectedFile.name : 'Choose file'}}</label>
  </div>
  <div class="progress" *ngIf="isUploading || percentCompleted > 0">
    <div class="progress-bar" role="progressbar" [ngStyle]="{'width': percentCompleted + '%'}" [attr.aria-valuenow]="percentCompleted" aria-valuemin="0"
      aria-valuemax="100">{{percentCompleted}}%</div>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button (click)="startUpload()" [disabled]="!selectedFile || percentCompleted > 0">Upload</button>
  <button mat-button [mat-dialog-close]="imageUrl" [disabled]="!imageUrl" cdkFocusInitial>Ok</button>
</mat-dialog-actions>